import React from 'react';
import Stopper, { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
const Error = () => {
  return <Stopper content={CONTENT.ERROR} />;
};

export default Error;
